export const ANDROID_AND_IOS_APP_SOURCE = 'app_webview';
export const STANDALONE_MEDIA_QUERY = '(display-mode: standalone)';

export const checkStandalone = (): boolean =>
  window.matchMedia(STANDALONE_MEDIA_QUERY).matches ||
  (window.navigator as any).standalone === true;

export const checkAndroidWebView = (): boolean =>
  /Android/i.test(navigator.userAgent) && /wv/.test(navigator.userAgent);

export const checkAndroidAppSource = (source: string | null): boolean =>
  source === ANDROID_AND_IOS_APP_SOURCE;

export const isPwaOrAndroidApp = (source: string | null): boolean =>
  checkStandalone() || checkAndroidWebView() || checkAndroidAppSource(source);
